




























import { Component, Vue } from 'vue-property-decorator';
import Title from '@/components/Title.vue';
import DailyBusinessTrendReport from '@/components/reports/DailyBusinessTrendReport.vue';
import DailyReportDate from '@/components/reports/DailyReportDate.vue';
import MixinBusinessTrendReport from '@/mixins/dailyBusinessTrendReport.mixin';

@Component({
  components: { 
    Title, 
    DailyBusinessTrendReport, 
    DailyReportDate 
  },
  mixins: [MixinBusinessTrendReport]
})
export default class MIReport extends Vue {}
